module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/iot-data-2015-05-28.paginators.json
// module id = 1273
// module chunks = 0